export default __webpack_public_path__ + "static/media/kathirkreations.e59f9c52.gif";